import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionItem, AppClientConfiguration, HttpService, ResponseStatus, ServiceResponse } from '@sdbn/appclient';
import { DialogService } from '@sdbn/common';

@Component({
  selector: 'app-action-tablet-barrier-hardware-event',
  templateUrl: './action-tablet-barrier-hardware-event.component.html',
  styleUrls: ['./action-tablet-barrier-hardware-event.component.scss']
})
export class ActionTabletHardwareEventItemComponent {

  @Input() actionItem: ActionItem;

  urls: Array<string>;

  formGroup = new FormGroup({
    numberPlate: new FormControl(null, [])
  })

  gateId: number;
  direction: string;

  messageDictionaryKey: string = null;

  constructor(
    private httpService: HttpService,
    private appClientConfiguration: AppClientConfiguration,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {

    let data = JSON.parse(this.actionItem.data);
    this.gateId = data.areaGateId;
    this.direction = data.direction;

  }

  public handleClick() {

    this.dialogService.showConfirm('tmc-common.ui.barrier-hardware-event-action-item.create-title', 'tmc-common.ui.barrier-hardware-event-action-item.create-message').afterClosed().subscribe(result => {
      if (result) {

        console.log(this.actionItem.data);
        this.httpService.postWithContext<ServiceResponse>(this.appClientConfiguration.serverURLRoot + '/tmc-common/hardware-event/createHardwareEvent',
          JSON.parse(this.actionItem.data)).subscribe(response => { });

      }
    })
  }

}
